import { render, staticRenderFns } from "./CertificateTypeLayer.vue?vue&type=template&id=4228ca67&scoped=true&"
import script from "./CertificateTypeLayer.vue?vue&type=script&lang=js&"
export * from "./CertificateTypeLayer.vue?vue&type=script&lang=js&"
import style0 from "./CertificateTypeLayer.vue?vue&type=style&index=0&id=4228ca67&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228ca67",
  null
  
)

export default component.exports